import React, { useEffect, useState } from 'react';
import { Avatar, Button, Dropdown, Form, Input, Modal, Switch, Table, Upload } from 'antd';
import { MoreOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { createTeamMember, deleteMember, editMember, getAllMembers } from '../../app/api';
import { toast } from 'react-toastify';
import { useMemberContext } from '../../context/MembersContext';

const TeamList = () => {
    const { members, setMembers } = useMemberContext();
    const [search, setSearch] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const [isFetchData, setIsFetchData] = useState(false);
    const [editingTeamMember, setEditingTeamMember] = useState(null);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [isBtnDiasabled, setIsBtnDiasabled] = useState(false);

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);

    const [form] = Form.useForm();

    const showModal = () => setIsModalOpen(true);

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
            if (e.target.value === "") {
        }
    };

    const handleCancel = () => {
        setEditingTeamMember(null);
        setIsModalOpen(false);
        form.resetFields();
    };

    const handleTableChange = (pagination) => {
        setPage(pagination.current);
        setLimit(pagination.pageSize);
    };

    const columns = [
        {
          title: '№',
          dataIndex: 'index',
          key: 'index',
          render: (text, record, index) => (page - 1) * limit + index + 1,
        },
        {
          title: 'Լուսանկար',
          dataIndex: 'photoUrl',
          render: (url, record) => (
                // <img alt="ki" src='https://autoservice-box.pub-ef0c1a9105be4cae99789e4583795d5e.r2.dev/team-members/1745564587988-315608873.png'/>
                 <Avatar
                    src={url ? `data:image/png;base64,${url}` : undefined}
                    alt="Team Member"
                    size={64}
                >
                    {!url && record.name?.charAt(0)}
                </Avatar>
            )
        },
        {
          title: 'Անուն',
          dataIndex: 'name',
        },
        {
          title: 'Հեռախոս',
          dataIndex: 'phoneNumber',
          render: (text) => text || '—',
        },
        {
          title: 'Հասցե',
          dataIndex: 'address',
          render: (text) => text || '—',
        },
        {
          title: 'Մասնագիտություն',
          dataIndex: 'position',
          render: (text) => text || '—',
        },
        {
          title: 'Նկարագրություն',
          dataIndex: 'description',
          render: (text) => text || '—',
        },
        {
          title: 'Ակտիվ է',
          dataIndex: 'isActive',
          render: (value) => (value ? '✅' : '❌'),
          align: 'center',
        },
        {
          title: 'Ավելացման ամսաթիվ',
          dataIndex: 'createdAt',
          render: (date) => new Date(date).toLocaleDateString('hy-AM'),
        },
        {
          title: 'Գործողություններ',
          key: 'actions',
          align: 'center',
          render: (_, record) => {
            const menuItems = [
              {
                key: 'edit',
                label: '✏️ Խմբագրել',
                onClick: () => onEdit(record),
              },
              {
                key: 'delete',
                label: '🗑️ Ջնջել',
                danger: true,
                onClick: () => onDelete(record.id),
              },
            ];
      
            return (
              <Dropdown
                menu={{ items: menuItems }}
                trigger={['click']}
                placement="bottomRight"
              >
                <Button type="text" icon={<MoreOutlined />} />
              </Dropdown>
            );
          },
        },
    ];

    const onEdit = (member) => {
        form.setFieldsValue({
            name: member.name,
            position: member.position,
            phoneNumber: member.phoneNumber,
            address: member.address,
            description: member.description,
            isActive: member.isActive,
        });
        setImageUrl(member.photoUrl);
        setIsModalOpen(true);
        setEditingTeamMember(member);
    };

    const onDelete = (memberId) => {
        Modal.confirm({
            title: 'Դուք համոզվա՞ծ եք',
            okText: 'Այո',
            okType: 'danger',
            cancelText: 'Ոչ',
            onOk: async () => {
                try {
                    const result = await deleteMember(memberId);
                    if (result.status === 200) {
                        setMembers(prev => prev.filter(item => item.id !== memberId));
                        getMembers();
                    }
                } catch (error) {
                    console.error('Error deleting transaction:', error);
                }
            },
            onCancel() {
            console.log('Delete operation canceled');
            },
        });
    }

    const handleChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
      };
    
    const handleBeforeUpload = (file) => {
        return false;
    };

    const handleAdd = async (values) => {
        setIsBtnDiasabled(true);
        try {
            // const { photoUrl } = values;
            
            // const formData = new FormData();
    
            // for (let key in values) {
            //     if (key !== "photoUrl") { 
            //       formData.append(key, values[key]);
            //     }
            // }
    
            // if (photoUrl) {
            //     formData.append("file", photoUrl.file);
            // }
            
            const payload = {
                ...values,
                photoUrl: imageUrl,
            };
    
            setIsFetchData(true);
            let response;
            if (editingTeamMember) {
                response = await editMember(editingTeamMember.id, payload);
            } else {
                response = await createTeamMember(payload);
            }
            
            if (response.status === 200 || response.status === 201) {
                setIsModalOpen(false);
                setIsFetchData(false);
                form.resetFields();
                setEditingTeamMember(null);
                getMembers();
                toast.success(`${editingTeamMember ? "Հաջողությամբ փոփոխվեց" : "Հաջողությամբ ավելացվեց"}`);
            } else if (response.statusCode === 400) {
                toast.error(response.message);
            }
        } catch(err) {
            console.log("Error", err)
        } finally {
            setIsBtnDiasabled(false);
        }
    };

    const getMembers = async () => {
        setLoading(true);
        const data = {
            search,
            page,
            limit
        }
        const allData = await getAllMembers(data);
        
        const all_members = allData?.data;
        if (allData?.status === 200) {
            setMembers(all_members?.data);
            setTotal(all_members.total);
            setLoading(false);
            if (all_members.data.length === 0) {
                setDisabled(true);
            } else {
                setDisabled(false);
            }
        }
    };

    useEffect(() => {
        if (search) {
            const delayDebounceFn = setTimeout(() => {
            getMembers();
            }, 500);
            return () => clearTimeout(delayDebounceFn);
        } else {
            getMembers();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search, page, isFetchData]);

    return (
        <div style={{ padding: 20 }}>
            <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
                <Input
                    placeholder="Որոնել..."
                    prefix={<SearchOutlined />}
                    disabled={disabled}
                    value={search}
                    onChange={handleSearchChange}
                    allowClear
                    style={{ width: 200 }}
                />
                <Button type="primary"  onClick={showModal}>
                    Ավելացնել Աշխատակից
                </Button>
            </div>

            <Modal
                title='Ավելացնել Աշխատակից'
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
            >
                <Form layout="vertical" onFinish={handleAdd} form={form} initialValues={{
                        isActive: true,      // Ներդնում ենք true որպես սկզբնական արժեք
                        description: '',     // Ներդնում ենք դատարկ տող որպես սկզբնական արժեք
                    }}>
                    <Form.Item
                        label="Անուն"
                        name="name"
                        rules={[{ required: true, message: 'Խնդրում ենք մուտքագրել աշխատակցի անունը' }]}
                    >
                        <Input placeholder="Անուն" />
                    </Form.Item>

                    <Form.Item
                        label="Պաշտոն"
                        name="position"
                    >
                        <Input placeholder="Պաշտոն" />
                    </Form.Item>

                    <Form.Item
                        label="Հեռախոս"
                        name="phoneNumber"
                    >
                        <Input placeholder="Հեռախոսահամար" />
                    </Form.Item>

                    <Form.Item
                        label="Հասցե"
                        name="address"
                    >
                        <Input placeholder="Հասցե" />
                    </Form.Item>

                    {/* {!editingTeamMember ? <Form.Item
                        label="Լուսանկար"
                        name="photoUrl"
                    >
                        <Upload
                            fileList={fileList}
                            listType="picture"
                            showUploadList={true}
                            maxCount={1}
                            beforeUpload={handleBeforeUpload}
                            onChange={handleChange}
                            onRemove={() => setFileList([])}
                        >
                            <Button icon={<UploadOutlined />}>Ընտրել լուսանկար</Button>
                        </Upload>
                    </Form.Item> : null} */}

                    <Form.Item
                        label="Հասցե"
                        name="description"
                    >
                        <Input.TextArea placeholder="Նկարագրություն" />
                    </Form.Item>

                    <Form.Item
                        label="Ակտիվ է"
                        name="isActive"
                        valuePropName="checked"
                    >
                        <Switch defaultChecked={true} />
                    </Form.Item>

                    <Form.Item>
                        <Button disabled={isBtnDiasabled} type="primary" htmlType="submit">
                            Ավելացնել
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            <Table
                columns={columns}
                dataSource={members}
                rowKey="id"
                pagination={{
                    current: page,
                    pageSize: limit,
                    total: total
                }}
                scroll={{ x: 'max-content' }}
                loading={loading}
                onChange={handleTableChange}
            />
        </div>
    )
}

export default TeamList;